// Of the line-leading Markdown markers a doctor might type ("-", "+", "*", ">", "<"),
// ToastUI's WYSIWYG-to-markdown serializer already escapes all of them EXCEPT "+":
//   "-"  -> "\-"   (its list-detection regex)
//   "*"  -> "\*"   (always, as a paired emphasis char)
//   ">"  -> "\>"   (its blockquote-detection regex)
//   "<"  -> "\<"   (when tag-like; otherwise renders literally anyway)
// Its list-detection regex omits "+", so a line typed as plain text like "+ foo" is
// emitted unescaped and gets reparsed as a bullet list by the Markdown viewer downstream
// (the marker disappears). This fills that single gap by escaping a leading "+" bullet,
// mirroring what ToastUI already does for "-". A "+" not followed by whitespace is not a
// CommonMark bullet, so it is left untouched.

const FENCE_REGEX = /^ {0,3}(```|~~~)/
const PLUS_BULLET_REGEX = /^( {0,3})\+(?=[ \t])/

export const escapeLeadingPlusBullet = (markdown: string): string =>
  markdown
    .split("\n")
    .reduce<{ lines: string[]; inFencedCodeBlock: boolean }>(
      (acc, line) => {
        if (FENCE_REGEX.test(line)) {
          return { lines: [...acc.lines, line], inFencedCodeBlock: !acc.inFencedCodeBlock }
        }
        if (acc.inFencedCodeBlock) {
          return { lines: [...acc.lines, line], inFencedCodeBlock: acc.inFencedCodeBlock }
        }
        return {
          lines: [...acc.lines, line.replace(PLUS_BULLET_REGEX, "$1\\+")],
          inFencedCodeBlock: acc.inFencedCodeBlock,
        }
      },
      { lines: [], inFencedCodeBlock: false },
    )
    .lines.join("\n")
